import { createRoute } from '@tanstack/react-router'
import { Route as appLayoutRoute } from '../layout'

export const Route = createRoute({
  getParentRoute: () => appLayoutRoute,
  path: '/finance/vendor-bills/new',
}).lazy(() => import('./vendor-bills.new.lazy').then((d) => d.Route))
